/**
 * Ticket #48 — ajustement des heures à la souris (poignée basse des blocs).
 *
 * Partagé par le Planning et la saisie des temps calendaire, pour qu'un même
 * geste obéisse aux mêmes règles des deux côtés.
 */

/** Plafond d'heures sur une journée (miroir de la borne serveur des allocations). */
export const MAX_HOURS_PER_DAY = 12;

/**
 * Pas du geste : le paramètre `logtimeMinHours` (durée minimale d'une saisie,
 * réglé par un ADMIN). 0 ou valeur invalide ⇒ 1h, le comportement historique.
 */
export function normalizeHourStep(raw) {
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 && n <= MAX_HOURS_PER_DAY ? n : 1;
}

/** Arrondit au pas, puis borne à [pas, max]. */
export function snapHours(raw, step, max) {
  const snapped = Math.round(raw / step) * step;
  return Math.round(Math.min(max, Math.max(step, snapped)) * 100) / 100;
}
